import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../store";
import Button from "../../UI/Button";

import classes from './EarTrainerSetup.module.css';

const EarTrainerStartTrainingSelect = ({ trainingUnavailable, onStart }) => {
  const startTrainingText = "Start Training!";
  const stopTrainingText = "Stop Training";

  const dispatch = useDispatch();

  const earTrainerMode = useSelector((state) => state.earTrainerMode);

  const buttonOnClickHandler = () => {
    if (!earTrainerMode && onStart) { onStart(); return; }
    const newMode = earTrainerMode ? 0 : 1;
    dispatch(mainActions.setEarTrainerMode(newMode));
  };
  return (
    <tr>
      <td colSpan="2">
        <Button onClick={buttonOnClickHandler} className={classes.button} data-tour-target="ear-start"
          disabled={!earTrainerMode && trainingUnavailable}>
          {earTrainerMode ? stopTrainingText : startTrainingText}
        </Button>
      </td>
    </tr>
  );
};

export default EarTrainerStartTrainingSelect;
